import React, { useRef, useState } from "react";
import { Input, Col, Container, Row } from "reactstrap";
import { IDataTableSubTableProps } from "../../../interfaces/Index";
import editIcon from "../../../assets/images/edit-icon.svg";
import expandIcon from "../../../assets/images/expand-icon.svg";
import "./DataTableWithSubTable.scss";

const DataTableSubTable: React.FunctionComponent<IDataTableSubTableProps> = (
  props: IDataTableSubTableProps
) => {
  const renderTableHeaders = () => {
    const { handleAllRecordSelection, tableHeaderData, allRecordsChecked } =
      props;
    return tableHeaderData?.map((header, index) => {
      if (header.type === "checkbox") {
        return (
          <Col key={index} className="text-ellipsis column">
            <Input
              type={header.type}
              checked={allRecordsChecked}
              onClick={handleAllRecordSelection}
            />
          </Col>
        );
      }
      return (
        <Col lg="2" key={index} className="text-ellipsis column">
          {header.text}
        </Col>
      );
    });
  };

  const renderParentAndChild = (item: any, outerIndex: number) => {
    const { editRowHandler } = props;
    return item.map((data: any, innerIndex: any) => {
      if (innerIndex === 0) {
        return (
          <Row className="parent">
            <Col lg="1" className="column img-container">
              <img
                src={
                  item[0].categoryImage ||
                  "/static/media/icn_dummy_image.97cbeb46.svg"
                }
              />
            </Col>
            <Col lg="2" className="column">
              {item[0].categoryHandle}
            </Col>
            <Col lg="2" className="column">
              {item[0].categoryTitle}
            </Col>

            <div className="actions-container">
              <a
                href="javascript:void(0)"
                className="edit-action"
                onClick={(e) => editRowHandler?.(e, outerIndex, innerIndex)}
              >
                <img src={editIcon} />
              </a>
              <label htmlFor={`${outerIndex + 1}`} className="expand-action">
                <img src={expandIcon} />
              </label>
            </div>
          </Row>
        );
      } else {
        return (
          <Container className="child-container-row">
            <Row
              className="child-row"
              onClick={(e) => editRowHandler?.(e, outerIndex, innerIndex)}
            >
              <Col lg="1" className="text-ellipsis column img-container">
                <img
                  src={
                    data.categoryImage ||
                    "/static/media/icn_dummy_image.97cbeb46.svg"
                  }
                />
              </Col>
              <Col
                lg="2"
                className="text-ellipsis column"
                title={data.categoryHandle}
              >
                {data.categoryHandle}
              </Col>
              <Col
                lg="2"
                className="text-ellipsis column"
                title={data.categoryTitle}
              >
                {data.categoryTitle}
              </Col>
            </Row>
          </Container>
        );
      }
    });
  };

  const renderTableBody = () => {
    const { editRowHandler, tableBodyRowData } = props;
    return tableBodyRowData.map((item, index) => {
      if (item.length > 1) {
        return (
          <section>
            <input
              type="checkbox"
              className="toggle-row-checkbox"
              id={`${index + 1}`}
            />
            <Container className="parent-row toggle-row">
              {renderParentAndChild(item, index)}
            </Container>
          </section>
        );
      } else {
        return (
          <section>
            <Container className="parent-row toggle-row">
              <Row className="parent">
                <Col lg="1" className="column img-container">
                  <img
                    src={
                      item[0].categoryImage ||
                      "/static/media/icn_dummy_image.97cbeb46.svg"
                    }
                  />
                </Col>
                <Col lg="2" className="column">
                  {item[0].categoryHandle}
                </Col>
                <Col lg="2" className="column">
                  {item[0].categoryTitle}
                </Col>
                <div
                  className="optional-click-event"
                  onClick={(e) => editRowHandler?.(e, index, 0)}
                ></div>
              </Row>
            </Container>
          </section>
        );
      }
    });
  };

  const renderTableFooter = () => {
    const { tableFooterData, noSearchResultFlag, tableBodyRowData } = props;
    return (
      noSearchResultFlag &&
      tableBodyRowData &&
      tableBodyRowData.length === 0 && (
        <Row>
          <div className="no-search-found">
            <img src={tableFooterData?.imgSrc} alt={tableFooterData?.imgAlt} />
            <div className="no-search-title">{tableFooterData?.title}</div>
            <div className="no-search-sub-title">
              {tableFooterData?.subTtitle}
            </div>
          </div>
        </Row>
      )
    );
  };

  return (
    <Container fluid className="data-table-with-sub-table" id={props.tableId}>
      {props.tableHeaderData && props.tableHeaderData.length > 0 && (
        <Container fluid className="header-row">
          <Row className="table-header">{renderTableHeaders()}</Row>
        </Container>
      )}
      <Container fluid className="parent-container-row">
        {props.tableBodyRowData &&
          props.tableBodyRowData.length > 0 &&
          renderTableBody()}
      </Container>
      {props.tableFooterData && (
        <Container fluid className="table-footer">
          <Row>{renderTableFooter()}</Row>
        </Container>
      )}
    </Container>
  );
};

DataTableSubTable.defaultProps = {
  tableId: "tableId",
  tableHeaderData: null,
  tableFooterData: null,
  noSearchResultFlag: false,
  allRecordsChecked: false,
};

export default DataTableSubTable;
